import { render, staticRenderFns } from "./ArticleComoGerarLeadsComEbook.vue?vue&type=template&id=456f2cd0&"
import script from "./ArticleComoGerarLeadsComEbook.vue?vue&type=script&lang=js&"
export * from "./ArticleComoGerarLeadsComEbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports